import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateCiType, deleteCiType, createCiType, updateCiTypeIcon } from "../services/ciTypesApi";

export function useCreateCiType(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCiType,
    onSuccess: (data) => {
      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => (old ? [...old, data] : data));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateCiType(queryData, handleSuccess, handleError, extendedLog) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCiType,
    onSuccess: (data) => {
      if (extendedLog) console.log(data);
      console.log(`${data.name} has been saved successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      if (extendedLog) console.log(error.response?.data);
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useUpdateCiTypeIcon(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCiTypeIcon,
    onSuccess: (data) => {
      queryClient.setQueryData([queryData], (old) => old?.map((item) => (item.id === data.id ? data : item)));
      handleSuccess?.(data);
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}

export function useDeleteCiType(queryData, handleSuccess, handleError) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCiType,
    onSuccess: (_, publicId) => {
      console.log(`${publicId} has been removed successfully!`);
      queryClient.setQueryData([queryData], (old) => old?.filter((item) => item.public_id !== publicId));
      handleSuccess?.();
    },
    onError: (error) => {
      console.log(`${error.message || "error"}`);
      handleError?.(error);
    },
  });
}
